import { ChatRoomType, ChatParticipantStatus, type ChatRoomKind } from '@masters-club/types';

export interface ChatParticipant {
  id: number;
  type: 'user' | 'admin';
  firstName: string | null;
  lastName: string | null;
  username: string | null;
  hasActiveSubscription?: boolean;
  status: ChatParticipantStatus;
  isMuted: boolean;
  isBanned: boolean;
}

export interface ChatRoomWithStats {
  id: number;
  type: ChatRoomType;
  kind: ChatRoomKind;
  name: string | null;
  isActive: boolean;
  pinnedMessageId: number | null;
  lastMessageAt: string | null;
  createdAt: string;
  messagesCount: number;
  participantsCount: number;
  participants: ChatParticipant[];
}

export interface ChatMessageWithSender {
  id: number;
  chatRoomId: number;
  content: string;
  isSystemMessage: boolean;
  isPinned: boolean;
  isDeleted: boolean;
  isEdited: boolean;
  createdAt: string;
  sender: {
    type: 'user' | 'admin';
    id: number;
    firstName: string | null;
    lastName: string | null;
    username: string | null;
    hasActiveSubscription?: boolean;
  } | null;
}

export type ChatModerationActionType = 'WARNING' | 'MUTE' | 'KICK' | 'BAN' | 'MESSAGE_DELETED';

export interface ChatModerationAction {
  id: number;
  type: ChatModerationActionType;
  reason: string;
  duration: number | null;
  expiresAt: string | null;
  isActive: boolean;
  createdAt: string;
  revokedAt: string | null;
  revokeReason: string | null;
  user: {
    id: number;
    firstName: string | null;
    lastName: string | null;
    username: string | null;
  } | null;
  admin: {
    id: number;
    email: string;
    username: string;
  } | null;
  revokedByAdmin: {
    id: number;
    email: string;
    username: string;
  } | null;
  relatedMessage: {
    id: number;
    content: string;
    isDeleted: boolean;
    createdAt: string;
  } | null;
}

export const CHAT_ROOM_TYPE_LABELS: Record<ChatRoomType, string> = {
  [ChatRoomType.DIRECT]: 'Личный чат',
  [ChatRoomType.SUPPORT]: 'Поддержка',
  [ChatRoomType.GAME_LOBBY]: 'Игровое лобби',
  [ChatRoomType.GROUP]: 'Групповой чат',
};

export const CHAT_ROOM_TYPE_COLORS: Record<ChatRoomType, 'default' | 'secondary' | 'outline'> = {
  [ChatRoomType.DIRECT]: 'default',
  [ChatRoomType.SUPPORT]: 'secondary',
  [ChatRoomType.GAME_LOBBY]: 'outline',
  [ChatRoomType.GROUP]: 'default',
};

export const PARTICIPANT_STATUS_LABELS: Record<ChatParticipantStatus, string> = {
  [ChatParticipantStatus.ACTIVE]: 'Активен',
  [ChatParticipantStatus.LEFT]: 'Покинул',
  [ChatParticipantStatus.KICKED]: 'Исключён',
  [ChatParticipantStatus.BLOCKED]: 'Заблокирован',
};

export const PARTICIPANT_STATUS_COLORS: Record<ChatParticipantStatus, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  [ChatParticipantStatus.ACTIVE]: 'default',
  [ChatParticipantStatus.LEFT]: 'secondary',
  [ChatParticipantStatus.KICKED]: 'destructive',
  [ChatParticipantStatus.BLOCKED]: 'destructive',
};
